import React from 'react';
import PropTypes from 'prop-types';

import { ButtonArrowState, ErrorAlert, Loader, Modal, TertiaryButton, WarningAlert } from '@huggg/react-components';
import CopyableDetail from './CopyableDetail';

import MastercardIcon from 'assets/img/prepaid-cards/mastercard.svg';

import styles from "./prepaidCard.module.scss";

import dictionary from 'config/dictionary';
import ImageDetail from './ImageDetail';

const CardDetailsModal = ({ title, sensitiveCardData, isLoading, error, onClose }) => {
  const formattedCardNumber = sensitiveCardData && sensitiveCardData.cardNumber.replace(/(.{4})/g, '$1 ');
  const formattedExpiryDate = sensitiveCardData && sensitiveCardData.expiryDate.replace(/\d\d(\d{2})-(\d{2}).*/, '$2 / $1');

  return (
    <Modal title={title.toUpperCase()} onClose={onClose} className={styles.cardDetailsModal}>
      {isLoading && <Loader />}
      {error && <div className={styles.cardDetailsErrorContainer}><ErrorAlert message={dictionary.prepaidCards.errors.retrievingCardDetails} /></div>}
      {!isLoading && !error && sensitiveCardData && <>
        <div className={styles.cardDetailsModalContent}>
          <ImageDetail label={dictionary.prepaidCards.labels.cardType} detail={"Mastercard®"} image={<img src={MastercardIcon} alt="Mastercard Logo" />} />
          <CopyableDetail label={dictionary.prepaidCards.labels.nameOnCard} detail={sensitiveCardData.fullName} />
          <CopyableDetail label={dictionary.prepaidCards.labels.cardNumber} detail={formattedCardNumber} />
          <div>
            <CopyableDetail label={dictionary.prepaidCards.labels.expiryDate} detail={formattedExpiryDate} />
            <div style={{ marginTop: '12px' }} >
              <WarningAlert title='IMPORTANT!' message={dictionary.prepaidCards.copy.expiryWarning} />
            </div>
          </div>
          <CopyableDetail label={dictionary.prepaidCards.labels.cvv} detail={sensitiveCardData.cvv} />
          <TertiaryButton label={dictionary.prepaidCards.labels.closeThisWindow} onClick={onClose} arrow={ButtonArrowState.None} />
        </div>
      </>}
    </Modal>
  );
};

CardDetailsModal.propTypes = {
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  sensitiveCardData: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.object,
};

export default CardDetailsModal;
